import { Component, Prop, h, State } from '@stencil/core';
import convertToLinks from '../../utils/convert_to_links';
import { signaler } from '../../utils/signaler';

@Component({
  tag: 'ci-navigation',
  styleUrl: 'ci-navigation.scss',
  assetsDirs: ['.../assets'],
})
export class DefaultHeader {
  @Prop({ mutable: true }) ciHeaderMainClass: string;
  @State() apparelHeaderTest: boolean;

  // Declare the properties here
  private showOverlayTimeout: number;
  private hideOverlayTimeout: number;

  async componentWillLoad() {
    this.apparelHeaderTest = (await signaler.featureFlag('apparel_header_v3')) === 'test';
  }

  render() {
    const handleShowOverlay = (event) => {
      clearTimeout(this.hideOverlayTimeout);

      // Ensure target is not null
      const target = event.currentTarget;
      if (!target) return;

      this.showOverlayTimeout = window.setTimeout(() => {
        const panel = target.querySelector('.ciHeader-subNav-panel');
        if (!panel) return;

        const activePanels = document.querySelectorAll('.ciHeader-subNav-panel--active');
        const overlay = document.getElementsByClassName('ciHeader-overlay')[0];

        activePanels.forEach(activePanel => {
          activePanel.classList.remove('ciHeader-subNav-panel--active');
        });

        overlay.classList.add('active');
        panel.classList.add('ciHeader-subNav-panel--active');
      }, 200);
    };

    const handleHideOverlay = () => {
      clearTimeout(this.showOverlayTimeout);
      this.hideOverlayTimeout = window.setTimeout(() => {
        const activePanels = document.querySelectorAll('.ciHeader-subNav-panel--active');
        const overlay = document.getElementsByClassName('ciHeader-overlay')[0];

        overlay.classList.remove('active');
        activePanels.forEach(activePanel => {
          activePanel.classList.remove('ciHeader-subNav-panel--active');
        });
      }, 200);
    };




    return (
      <div class="ciHeader-subNav-wrapper" onMouseEnter={convertToLinks}>
        {this.apparelHeaderTest ? [
          <span class="ciHeader-subNav-item " id="productLink1" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
            <a href={`${process.env.CI_HOSTNAME}/products/apparel/857`} class="ciHeader-subNav-link">
              <span class="ciHeader-subNav-text js-ciHeader-track"
                data-section="apparel"
                data-link="apparel">Apparel</span>
            </a>
            <ci-apparel id="apparelProductOverlay" class="ciHeader-subNav-panel"></ci-apparel>
          </span>,
          <span class="ciHeader-subNav-item " id="productLink2" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
            <a href={`${process.env.CI_HOSTNAME}/products/promotional-products/218`} class="ciHeader-subNav-link">
              <span class="ciHeader-subNav-text js-ciHeader-track"
                data-section="promotional products"
                data-link="promotional products">Promotional Products</span>
            </a>
            <ci-promo-products id="promoProductOverlay" class="ciHeader-subNav-panel"></ci-promo-products>
          </span>
        ] : [
          <span class="ciHeader-subNav-item " id="productLink" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
            <a href={`${process.env.CI_HOSTNAME}/products`} class="ciHeader-subNav-link">
              <span class="ciHeader-subNav-text js-ciHeader-track"
                data-section="products"
                data-link="products">Products</span>
            </a>
            <ci-products id="productOverlay" class="ciHeader-subNav-panel"></ci-products>
          </span>
        ]}

        <span class="ciHeader-subNav-item" id="designLink" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <a href={`${process.env.CI_HOSTNAME}/lab`} class="ciHeader-subNav-link">
            <span class="ciHeader-subNav-text js-ciHeader-track"
            data-section="design lab"
            data-link="design lab">Design Lab</span>
          </a>
          <ci-design-lab id="designOverlay" class="ciHeader-subNav-panel"></ci-design-lab>
        </span>
        <span class="ciHeader-subNav-item " id="templatesLink" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <a href={`${process.env.CI_HOSTNAME}/inspiration`} class="ciHeader-subNav-link">
            <span class="ciHeader-subNav-text js-ciHeader-track"
            data-section="templates"
            data-link="templates">Templates</span>
          </a>
          <ci-template id="templatesOverlay" class="ciHeader-subNav-panel"></ci-template>
        </span>
        <span class="ciHeader-subNav-item" id="solutionsLink" onMouseEnter={handleShowOverlay} onMouseLeave={handleHideOverlay}>
          <span class="ciHeader-subNav-link">
            <span class="ciHeader-subNav-text js-ciHeader-track"
            data-section="solutions"
            data-link="solutions">Solutions</span>
          </span>
          <ci-solutions id="solutionsOverlay" class="ciHeader-subNav-panel"></ci-solutions>
        </span>
      </div>
    );
  }
}
